const GOOGLE_MAPS_GEOCODE_URL = 'https://maps.google.com/maps/api/geocode/';
const GEOCODE_STATUS = { OK: 'OK', ZERO_RESULTS: 'ZERO_RESULTS' };

/**
 * Geocodes an address or postal code to coordinates using the Google Maps Geocoding API.
 * @param {string} addressOrPostalCode - Address or postal code to geocode.
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code to restrict results.
 * @param {string} apiKey - Google Maps API key.
 * @returns {Promise<{lat: number, lng: number}|null>} Resolved coordinates, or null if
 *   no results were found. Rejects on network errors or API errors
 *   (e.g. REQUEST_DENIED, OVER_QUERY_LIMIT, INVALID_REQUEST).
 */
async function geocodeAddress(addressOrPostalCode, countryCode, apiKey) {
  const url =
    `${GOOGLE_MAPS_GEOCODE_URL}json` +
    `?address=${encodeURIComponent(addressOrPostalCode)}` +
    `&components=country:${countryCode}` +
    `&key=${apiKey}`;
  const res = await fetch(url).then((r) => r.json());
  if (res.status === GEOCODE_STATUS.ZERO_RESULTS) return null;
  if (res.status !== GEOCODE_STATUS.OK) {
    throw new Error(`Geocoding API error: ${res.status}`);
  }
  return res.results?.[0]?.geometry?.location ?? null;
}

module.exports = {
  geocodeAddress,
};
